import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

export const insurancePolicySummariesQueryKey = (personId: string) => [
  'insurancePolicies',
  personId,
  'summary'
];

export const useInsurancePolicySummaries = (personId: string) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: insurancePolicySummariesQueryKey(personId),
    queryFn: () => insuranceRepository.getInsurancePolicySummaries(personId),
    select: (data) => data.results,
    enabled: !!personId
  });
};

export default useInsurancePolicySummaries;
